import { useCallback } from 'react';

import { DEFAULT_APP_STORE_URL } from '../constants/appInfo';

const useDeepLink = (
  iosAppLink: string,
  onTimeout?: () => void, // Optional callback function
): (() => void) => {
  const openAppOrFallback = useCallback(() => {
    const now = Date.now();
    const TIMEOUT = 2000; // A 2-second timeout

    window.location.href = iosAppLink; // Attempt to open the app with its URL scheme

    setTimeout(() => {
      if (Date.now() - now < TIMEOUT + 100) {
        if (onTimeout) {
          onTimeout();
        } else {
          // Opens App Store link in a new tab if no timeout callback is provided
          window.open(DEFAULT_APP_STORE_URL, '_blank', 'noopener,noreferrer');
        }
      }
    }, TIMEOUT);
  }, [iosAppLink, onTimeout]);

  return openAppOrFallback;
};

export default useDeepLink;
